import { render, staticRenderFns } from "./GoalDetail.vue?vue&type=template&id=6914a72a&scoped=true"
import script from "./GoalDetail.vue?vue&type=script&lang=js"
export * from "./GoalDetail.vue?vue&type=script&lang=js"
import style0 from "./GoalDetail.vue?vue&type=style&index=0&id=6914a72a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6914a72a",
  null
  
)

export default component.exports